import logo from '../../../assets/images/bebrave-logo.png';

export const MessageLoading = () => {
    return (
        <div className="flex justify-start items-center">
            <img
                className="w-7 h-7 border-[1px] p-1 rounded-full outline-gray-200 bg-primary-50"
                src={logo}
                alt="bebrave logo"
            />
            <div className="py-2 px-4">
                <div className="rounded-full bg-primary-50 p-1.5">
                    <div className="flex gap-1">
                        <div className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary-600" />
                        <div
                            className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary-600"
                            style={{ animationDelay: '0.2s' }}
                        />
                        <div
                            className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary-600"
                            style={{ animationDelay: '0.4s' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};